/* NZ Supps — Build Your Stack free-item cleanup (Blake 2026-06-27).
   Removes orphaned/over-earned FREE items (_Free) from the cart when the shopper is no longer
   getting them through a valid stack. Tier-aware (mirrors the discount Function):
     picks  = distinct stack categories among PAID _Stack lines (via the line's Category property)
     samples (_Free "Sample")        earned at >=3 picks, cap 5 units
     mystery (_Free "Mystery gift")  earned at >=4 picks, cap 1 unit
   Any _Free line beyond what's currently earned is reduced/removed. Never runs on the stack pages
   (build-your-stack / your-stack) so it can't race the commit. Runs on page load + bfcache restore. */
(function () {
  var path = location.pathname || '';
  if (/\/pages\/(build-your-stack|your-stack)\b/.test(path)) return; // inside the flow: leave the cart alone
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var running = false;

  function cleanup() {
    if (!/(?:^|; )cart=/.test(document.cookie)) return; // NZS-SPD-0927-B4: no cart cookie = empty cart = nothing to clean
    if (running) return; running = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!items.some(function (it) { return it.properties && it.properties._Free; })) return; // nothing free to police
        // picks = distinct categories among PAID stack lines
        var cats = {};
        items.forEach(function (it) {
          var pr = it.properties || {};
          if (pr._Stack && !pr._Free && pr.Category) cats[String(pr.Category).toLowerCase()] = 1;
        });
        var picks = Object.keys(cats).length;
        var sampleBudget = picks >= 3 ? 5 : 0;
        var mysteryBudget = picks >= 4 ? 1 : 0;
        // build the list of line adjustments (qty 0 = remove, or trim to remaining budget)
        var changes = [];
        items.forEach(function (it) {
          var fv = (it.properties || {})._Free;
          if (!fv) return;
          var isMystery = /mystery/i.test(fv);
          var budget = isMystery ? mysteryBudget : sampleBudget;
          var keep = Math.max(0, Math.min(it.quantity, budget));
          if (isMystery) mysteryBudget -= keep; else sampleBudget -= keep;
          if (keep < it.quantity) changes.push({ key: it.key, qty: keep });
        });
        if (!changes.length) return;
        // apply sequentially by line key (keys are stable across other lines' removal)
        return changes.reduce(function (chain, c) {
          return chain.then(function () {
            return fetch(ROOT + 'cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: c.key, quantity: c.qty })
            }).catch(function () { /* tolerate per-line failure */ });
          });
        }, Promise.resolve()).then(function () { return fetch(ROOT + 'cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (fresh) {
            // refresh the cart badge + let the drawer re-render next open
            var n = fresh && fresh.item_count;
            if (typeof n === 'number') {
              document.querySelectorAll('#nzsCartDot, .cartdot, [data-cart-count]').forEach(function (el) {
                el.textContent = n; el.hidden = n === 0;
              });
            }
            document.dispatchEvent(new CustomEvent('nzs:cart-changed', { detail: fresh }));
          });
      })
      .catch(function () { /* never break the page over cleanup */ })
      .then(function () { running = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanup);
  else cleanup();
  window.addEventListener('pageshow', function (e) { if (e.persisted) cleanup(); }); // back/forward bfcache
})();
